module.exports = __webpack_public_path__ + "img/webtoon_title_improved.1f74f45.png";